import { axios, axios2 } from '@/lib/axios';
export type SinglePayment = {
  property_type: string;
  property_id: string;
  payment_token?: string;
  price: string;
  form_id: string;
};
export const addSinglePayment = (data: SinglePayment) => {
  return axios2.post('/customer-api/pay-do-it-reeipo', data);
};

export const payAdminCommision = (data: SinglePayment) => {
  return axios2.post('/customer-api/admin-cut', data);
}; 
